import React from 'react'
import { observer } from 'mobx-react'
import { useTranslation } from 'react-i18next'
import { RiEmotionSadLine } from '@react-icons/all-files/ri/RiEmotionSadLine'

export const NotAvailable: React.FC = observer(() => {
  const { t } = useTranslation()

  return (
    <div className="bg-smoke p-8 flex flex-col items-center justify-center">
      <h1>{t('notAvailable')}</h1>
      <RiEmotionSadLine size={32} className="mt-8"></RiEmotionSadLine>
    </div>
  )
})
